import { render } from "./index.vue?vue&type=template&id=22bfad6f&scoped=true"
import script from "./index.js?vue&type=script&lang=js"
export * from "./index.js?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=22bfad6f&lang=scss"
import "./index.vue?vue&type=style&index=1&id=22bfad6f&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bfad6f"]])

export default __exports__